// Bootstrap

import "bootstrap/js/dist/base-component";
import "bootstrap/js/dist/alert";
import "bootstrap/js/dist/button";
import "bootstrap/js/dist/carousel";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/offcanvas";
import "bootstrap/js/dist/popover";
import "bootstrap/js/dist/scrollspy";
import "bootstrap/js/dist/tab";
import "bootstrap/js/dist/toast";
import "bootstrap/js/dist/tooltip";

// var tooltipTriggerList = [].slice.call(
// 	document.querySelectorAll('[data-bs-toggle="tooltip"]')
// );
// var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
// 	return new bootstrap.Tooltip(tooltipTriggerEl);
// });

// var popoverTriggerList = [].slice.call(
// 	document.querySelectorAll('[data-bs-toggle="popover"]')
// );
// var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
// 	return new bootstrap.Popover(popoverTriggerEl);
// });


// Custom
import InitGsap from './InitGsap';
import InitFAQ from './InitFAQ';
import InitJumpLinks from './InitJumpLinks';
import InitSwiper from './InitSwiper';
import InitVideoPlayer from './InitVideoPlayer';
import InitActivityCards from './InitActivityCards';
import InitNavScroll from './InitNavScroll';
import InitAccordion from './InitAccordion';
import InitOffcanvasNav from './InitOffcanvasNav';
import InitNavDropdown from './InitNavDropdown';
import InitStickyBookNow from './InitStickyBookNow';

InitGsap();
InitFAQ();
InitJumpLinks();
InitSwiper();
InitVideoPlayer();
InitActivityCards();
InitNavScroll();
InitAccordion();
InitOffcanvasNav();
InitNavDropdown();
InitStickyBookNow();


// Select the banner and the target section
const banner = document.querySelector('#booknowbanner');
const targetSection = document.querySelector('#book-now');

// Configuration for the observer
const options = {
  root: null, // use the viewport
  threshold: 0.1 // trigger when 10% of the section is visible
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      // #book-now is in view: Hide the banner
      banner.classList.add('hidden');
    } else {
      // #book-now is out of view: Show the banner
      banner.classList.remove('hidden');
    }
  });
}, options);

// Start observing
observer.observe(targetSection);
